var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommended-ingredient flex--align-center"},[_c('div',{staticClass:"recommended-ingredient__icon",style:({ 'background-color': _vm.ingredient.color })}),_c('span',{staticClass:"recommended-ingredient__name"},[_vm._v(" "+_vm._s(_vm.$t(`dashboard.ingredients.${_vm.ingredient.name}`))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }